<template>
  <div>
    <div class="block jumbotron jumbotron-full-image">
      <div class="block__content">
        <div class="jumbotron__content">
          <div class="jumbotron__text jumbotron__text--wide">
            <h1
              class="h1 mb-0"
              v-html="$t('pages.invoiceTemplatesPDF.section_1.heading')"
            />
          </div>
          <div class="jumbotron__img mx-auto">
            <img
              :src="require('~/images/header-pdf-templates.svg')"
              :alt="$t('pages.invoiceTemplatesPDF.section_1.heading')"
              width="300"
              height="225"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="block block--bottom-none">
      <div class="block__content">
        <p
          class="text-center mw-1050 mx-auto"
          v-html="$t('pages.invoiceTemplatesPDF.section_2.text_1')"
        />
        <p
          class="text-left mx-auto block--top-sm"
          v-html="$t('pages.invoiceTemplatesPDF.section_2.text_2')"
        />
      </div>
    </div>

    <div class="block block--top-none block--bottom-sm">
      <div class="block__content">
        <div class="block__text mw-1050">
          <ul>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_1')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_2')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_3')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_4')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_5')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_6')" />
              </div>
            </li>
            <li>
              <div>
                <p v-html="$t('pages.invoiceTemplatesPDF.section_2.step_7')" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <div class="block__content">
        <p
          class="text-center mw-820 mx-auto mb-30"
          v-html="$t('pages.invoiceTemplatesPDF.section_2.text_3')"
        />
        <div class="text-center mb-40 mt-40">
          <Button
            :to="PATH_INVOICE"
            icon="icon icon-invoice-new"
            size="large"
            new-design
            type="warning"
          >
            {{ $t("pages.invoiceTemplatesPDF.section_2.cta") }}
          </Button>
        </div>
      </div>
    </div>

    <div class="block block--top-sm block--bottom-sm">
      <div class="block__content">
        <h2 class="h2">
          <strong
            v-html="$t('pages.invoiceTemplatesPDF.section_3.heading')"
          />
        </h2>
      </div>
      <div class="block__content block__content--with-image">
        <div class="block__text">
          <ol class="list-numbered">
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_1')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_2')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_3')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_4')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_5')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.invoiceTemplatesPDF.section_3.step_6')" />
              </div>
            </li>
          </ol>
        </div>
        <div class="block__image block__image--with-margin">
          <img
            :src="require('~/images/word-excel-illustration.svg')"
            alt="Word / Excel"
            width="529"
            height="594"
          >
        </div>
      </div>
    </div>

    <div class="block block--top-sm block--bottom-sm">
      <div class="block__content text-center">
        <p
          class="mt-60 mb-40 fs-17"
          v-html="$t('pages.invoiceTemplatesPDF.section_4.text_1')"
        />
        <Button
          :to="PATH_INVOICE"
          icon="icon icon-invoice-new"
          size="large"
          new-design
          type="warning"
        >
          {{ $t("pages.invoiceTemplatesPDF.section_4.cta") }}
        </Button>
        <p class="mt-60 mb-40 fs-17">
          {{ $t("pages.invoiceTemplatesPDF.section_4.text_2") }}
        </p>
        <div class="el-button-grp">
          <Button
            @click="openImgModal(imagePathPDF)"
            icon="icon icon-pdf"
            size="medium"
            new-design
            type="warning"
            plain
            data-test="excel-button"
          >
            {{ $t("pages.invoiceTemplatesPDF.section_4.cta_2") }}
          </Button>
        </div>
      </div>
    </div>
    <InfoPanel />
    <TemplatesPDF
      :visible.sync="showImgModal"
      :img-source="imgSource"
      @create-invoice="createInvoice"
      @close-modal="handleClose"
    />
  </div>
</template>

<script>
import {
  PATH_INVOICE,
} from '~/router';

export default {
  name: 'NewBies',
  components: {
    InfoPanel: () => import('~/components/InfoPanel.vue'),
    TemplatesPDF: () => import('~/components/dialogs/TemplatesPDF.vue'),
  },
  data() {
    return {
      PATH_INVOICE,
      showImgModal: false,
      imgSource: '',
    };
  },
  computed: {
    imagePathPDF() {
      return this.$t('pages.invoiceTemplatesPDF.section_4.link_1');
    },
  },
  methods: {
    openImgModal(imgPath) {
      this.imgSource = imgPath;
      this.showImgModal = true;
    },
    createInvoice() {
      this.$router.push({
        name: PATH_INVOICE,
      });
    },
    handleClose() {
      this.showImgModal = false;
    },
  },
};
</script>
